import React from 'react';
import './ClassificaCard.css';

/**
 * Un riquadro di classifica: titolo, icona, e i primi cinque.
 *
 * Esisteva già, ma dentro `Edizione.jsx`, e serviva anche nell'ingresso della sezione, dove le
 * stesse classifiche si vedono calcolate su tutti i tornei invece che su una edizione sola.
 * Copiarlo avrebbe prodotto due riquadri destinati a divergere alla prima modifica: è la
 * ragione per cui vive qui e le due pagine lo condividono.
 *
 * Il componente sa disporre una classifica e non sa niente del dominio: chi lo usa gli passa le
 * voci già pronte, con il nome come nodo — così può essere un link — e il contesto che ha senso
 * lì (la squadra di quella edizione, il gruppo scout, o niente).
 *
 * voci: [{ chiave, nome, contesto?, valore }]
 */
export default function ClassificaCard({ titolo, icona: Icona, tono, voci }) {
  return (
    <div className={`statistiche-personal-ranking-card ${tono}`}>
      <div className="statistiche-personal-ranking-header">
        <Icona className={`statistiche-personal-ranking-icon ${tono}`} aria-hidden="true" />
        <h3 className="statistiche-personal-ranking-title">{titolo}</h3>
      </div>

      <div className="statistiche-personal-ranking-content">
        {voci?.length ? (
          <ol className="statistiche-personal-ranking-list">
            {voci.map((v, i) => (
              <li className="statistiche-personal-ranking-item" key={v.chiave}>
                <span className="statistiche-personal-rank-number">{i + 1}</span>
                <span className="statistiche-personal-player-info">
                  <span className="statistiche-personal-player-name">{v.nome}</span>
                  {v.contesto ? <span className="statistiche-personal-player-team">{v.contesto}</span> : null}
                </span>
                <span className="statistiche-personal-stat-value">{v.valore ?? 0}</span>
              </li>
            ))}
          </ol>
        ) : (
          <div className="statistiche-personal-no-data">Nessun dato disponibile</div>
        )}
      </div>
    </div>
  );
}
